import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "navbar has-shadow is-fixed-top",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_2 = { class: "navbar-brand" }
const _hoisted_3 = {
  class: "navbar-item",
  href: "/"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "navbar-start" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "elichens elichens-home m-1 is-size-4" }, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "elichens elichens-settings m-1 is-size-4" }, null, -1 /* HOISTED */)
const _hoisted_8 = { class: "navbar-end" }
const _hoisted_9 = { class: "avatar" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "navbar-dropdown" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.tenantIcon,
          alt: "elichens",
          class: "mb-2"
        }, null, 8 /* PROPS */, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_link, {
        to: "/dashboard",
        custom: ""
      }, {
        default: _withCtx(({isActive}) => [
          _createElementVNode("a", {
            class: _normalizeClass(["navbar-item is-size-5 has-text-weight-semibold", {'is-active': isActive}]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/dashboard')))
          }, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('headbar.dashboard')), 1 /* TEXT */)
          ], 2 /* CLASS */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_router_link, {
        to: "/preferences",
        custom: ""
      }, {
        default: _withCtx(({isActive}) => [
          _createElementVNode("a", {
            class: _normalizeClass(["navbar-item is-size-5 has-text-weight-semibold", {'is-active': isActive}]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/preferences')))
          }, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('headbar.preferences')), 1 /* TEXT */)
          ], 2 /* CLASS */)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.user)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["navbar-item has-dropdown", { 'is-active': _ctx.showProfileMenu }])
          }, [
            _createElementVNode("a", {
              class: "navbar-link",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleUserProfileMenu && _ctx.toggleUserProfileMenu(...args)))
            }, [
              _createTextVNode(_toDisplayString(_ctx.user.username) + " ", 1 /* TEXT */),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("img", {
                  src: _ctx.userAvatar,
                  alt: "avatar"
                }, null, 8 /* PROPS */, _hoisted_10)
              ])
            ]),
            (_ctx.showProfileMenu)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "profile-menu-background",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleUserProfileMenu && _ctx.toggleUserProfileMenu(...args)))
                }))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_router_link, {
                class: "navbar-item",
                to: "/preferences#my-account"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('headbar.my_account')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createElementVNode("a", {
                class: "navbar-item has-text-danger has-text-weight-semibold",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
              }, _toDisplayString(_ctx.$t('headbar.disconnect')), 1 /* TEXT */)
            ])
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}